import React from 'react';
import { useNavigate } from 'react-router-dom';
import { typography } from '../../styles/typography';
import BarChart from '../ui/BarChart';

const ZoomedChartView = ({
  title,
  yAxisLabel,
  xAxisLabel,
  barColor = '#22c55e',
  data,
  labels,
  weekRange,
  selectedDate,
  onDateSelect,
  isCalendarOpen,
  onCalendarToggle,
  isLoading = false
}) => {
  const navigate = useNavigate();

  // Ensure data is always an array
  const chartData = Array.isArray(data) ? data : [];
  const chartLabels = Array.isArray(labels) ? labels : [];

  const handleGoBack = () => {
    navigate('/dashboard-ti-dashboard');
  };

  const handleClose = () => {
    navigate('/dashboard-ti-dashboard');
  };

  return (
    <div className="w-full h-full overflow-hidden">
      {/* Header Section */}
      <div className="mb-3">
        <div className="flex justify-between items-start gap-4">
          <div className="flex-1 min-w-0">
            <h1 className={`${typography.h3} text-black mb-2 truncate`}>{title}</h1>
            <p className={`${typography.p} text-black`}>
              Select the week to view the Analysis <span className="font-bold">Across All Sites</span>
            </p>
          </div>
          <button
            onClick={handleClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors flex-shrink-0"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Week Selection Card */}
      <div className="mb-8">
        <div
          className="w-full max-w-96 p-3 bg-neutral-50/50 rounded-xl flex justify-between items-center cursor-pointer hover:bg-neutral-50/60 transition-colors"
          onClick={onCalendarToggle}
        >
          <p className={`${typography.p} text-black`}>
            {weekRange || 'Loading...'}
          </p>
          <div className="w-6 h-6 relative overflow-hidden">
            {/* Calendar Icon */}
            <svg
              className="w-5 h-5 text-black"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Chart Container */}
      <div className="w-full">
        {isLoading ? (
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-center h-[500px]">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
                <p className="mt-4 text-gray-600">Loading data...</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full" style={{ height: '500px' }}>
            <BarChart
              data={chartData}
              labels={chartLabels}
              title={title}
              xAxisLabel={xAxisLabel}
              yAxisLabel={yAxisLabel}
              barColor={barColor}
              showExpandIcon={false}
              className="w-full h-full"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ZoomedChartView;

